import React, { FC } from 'react';
import styles from './styles.module.scss';

type Option = { value: string; label: string };

export const SelectInput: FC<{
    label: string;
    placeholder?: string;
    options: Option[];
    value?: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}> = ({ label, placeholder = 'Select...', options, value = '', onChange, disabled }) => {
    return (
        <div className={styles.formGroup}>
            <label>{label}</label>

            <select
                value={value}
                disabled={disabled}
                onChange={(e) => onChange(e.currentTarget.value)}
            >
                <option value="" disabled>
                    {placeholder}
                </option>

                {options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
